import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LazyMotion, domAnimation } from 'motion/react';
import { App } from './App';
import { useAuthStore } from './stores/auth';
import { useThemeStore } from './stores/theme';
// Inter self-hosted (fontsource) — pesos usados pelo DESIGN (regular/medium/semibold/bold).
// Sem Google Fonts (o CSS + .woff2 entram no bundle do Vite; funciona offline/CSP).
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
  },
});

// Tema segue a preferência do usuário: ao carregar/trocar a sessão, sincroniza
// o store de tema com user.theme (a fonte da verdade é o servidor).
useAuthStore.subscribe((state, prev) => {
  const theme = state.user?.theme;
  if (theme && theme !== prev.user?.theme) {
    useThemeStore.getState().hydrateFromUser(theme);
  }
});

const root = document.getElementById('root');
if (!root) throw new Error('#root não encontrado');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* strict => usar apenas <m.*>, nunca <motion.*> (mantém o bundle leve) */}
      <LazyMotion features={domAnimation} strict>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </LazyMotion>
    </QueryClientProvider>
  </StrictMode>,
);
